import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataAlarme } from '../../data/DataAlarme';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxAlarme } from '../ComboBox/ComboBoxAlarme';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { EUIToggle } from '../EUI/EUIToggle';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { TimePicker } from '../Outils/TimePicker';

export class FicheAlarme extends Component {

    static defaultProps = {
        alarme: {
            alarmeDateHeure: Scriba.date().getChaineISOFromDate(Date.now()),
            alarmeLibelle: undefined,
            alarmeLue: false,
            idAlarme: undefined,
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            alarmeDateHeure: undefined,
            alarmeLibelle: undefined,
            alarmeLue: false,
            idAlarmeSelectionnee: undefined,
            onActiveBoutonEnregistrer: false,
        };
    };

    _estFicheOuverteEnModeCreation = () => {
        return !this.props.alarme.idAlarme;
    };

    _enregistrer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Enregistrement de l'alarme en cours..."
        });

        const { idAlarme, idOperation, idReservation, idContact, idSouhait, idDemande } = this.props.alarme;
        const { alarmeDateHeure, alarmeLibelle, alarmeLue } = this.state;
        const alarme = { idAlarme, idOperation, idReservation, idContact, idSouhait, idDemande, alarmeDateHeure, alarmeLibelle, alarmeLue };

        DataAlarme._onEnregistrementAlarme(alarme)
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null)
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onMiseAJour);
                else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            });

    };

    _onTimeChange = (type) => (event, option, index, value) => {
        let alarmeDateHeure = Scriba.date().getDateFromChaineISO(this.state.alarmeDateHeure);
        if (type === "h") {
            alarmeDateHeure.setHours(option.key);
        }
        else if (type === "mm") {
            alarmeDateHeure.setMinutes(option.key);
        }
        alarmeDateHeure = Scriba.date().getChaineISOFromDate(alarmeDateHeure);
        this.setState({ alarmeDateHeure }, this._onVerificationFormulaire);
    };

    _onOpen = () => {
        const { alarmeDateHeure, alarmeLibelle, alarmeLue } = this.props.alarme;
        this.setState(
            {
                alarmeDateHeure, alarmeLibelle, alarmeLue,
                idAlarmeSelectionnee: alarmeLibelle,
                onActiveBoutonEnregistrer: false
            },
            this._onVerificationFormulaire
        );
    };

    _onVerificationFormulaire = () => {
        const { alarmeDateHeure, alarmeLibelle, alarmeLue } = this.state;
        const alarme = { alarmeDateHeure, alarmeLibelle, alarmeLue };
        Immocom.fiche()._validationFormulaire(this, "Alarme", alarme, this._estFicheOuverteEnModeCreation() ? "Création" : "Modification");
    };

    _toggleDialogSuppression = (isOpen) => () => {
        this.setState({ afficherDialogSuppression: isOpen });
    };

    _supprimerAlarme = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression en cours..."
        });
        DataAlarme._onSuppressionAlarme(this.props.alarme.idAlarme).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                this.props.onMiseAJour();
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
        this._toggleDialogSuppression(false)();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { alarmeDateHeure, alarmeLibelle, alarmeLue, afficherDialogSuppression, idAlarmeSelectionnee, onActiveBoutonEnregistrer } = this.state;

        return <EUIPanel
            headerText={`${this._estFicheOuverteEnModeCreation() ? "Création" : "Modification"} d'une alarme`}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDelete={!this._estFicheOuverteEnModeCreation() && this._toggleDialogSuppression(true)}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onSave={this._enregistrer}
        >

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack>

                <MessageBars
                    errorMessage={this.state.errorMessage}
                    infoMessage={this.state.messageMessageBarFiltres}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                <ComboBoxAlarme
                    label="Libellé"
                    onChange={(event, option, index, value) => this.setState({ idAlarmeSelectionnee: option.key, alarmeLibelle: option.text }, this._onVerificationFormulaire)}
                    required
                    selectedKey={idAlarmeSelectionnee}
                />

                <EUIDatePicker
                    isRequired
                    label="Date"
                    onSelectDate={date => this.setState({ alarmeDateHeure: Scriba.date().getChaineISOFromDate(date) }, this._onVerificationFormulaire)}
                    value={alarmeDateHeure}
                />

                <TimePicker
                    heures={Scriba.date().stringDateFormat(alarmeDateHeure, "LT").split(":")[0]}
                    minutes={Scriba.date().stringDateFormat(alarmeDateHeure, "mm")}
                    onChangeHeure={this._onTimeChange("h")}
                    onChangeMinute={this._onTimeChange("mm")}
                    required
                />

                <EUIToggle
                    checked={!alarmeLue}
                    label="Active ?"
                    onChange={(e, isChecked) => this.setState({ alarmeLue: !isChecked }, this._onVerificationFormulaire)}
                />

            </Stack>

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._supprimerAlarme} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialogSuppression(false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppression}
                message="Confirmez-vous la suppression de cette alarme ?"
                onDismiss={this._toggleDialogSuppression(false)}
                titre="Suppression d'une alarme"
            />

        </EUIPanel>;

    };

};